import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';

function formatDateTime(dt: string): string {
  return new Date(dt).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export function AdminInvitationsPage() {
  const [codes, setCodes] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(5);
  const [validUntil, setValidUntil] = useState('');
  const [showForm, setShowForm] = useState(false);

  useEffect(() => { loadCodes(); }, []);

  async function loadCodes() {
    const { data, error } = await supabase
      .from('invitation_codes')
      .select('*, used_by_profile_id!inner(companies(name))')
      .order('created_at', { ascending: false });
    if (data) setCodes(data);
    setLoading(false);
  }

  async function generateCodes() {
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    const newCodes = [];

    for (let i = 0; i < count; i++) {
      let code = '';
      for (let g = 0; g < 3; g++) {
        if (g > 0) code += '-';
        for (let c = 0; c < 4; c++) code += chars[Math.floor(Math.random() * chars.length)];
      }

      await supabase.from('invitation_codes').insert({
        code,
        created_by_admin_id: '', // TODO: current admin ID
        valid_until: validUntil || null,
        is_active: true,
      });
      newCodes.push(code);
    }

    setShowForm(false);
    loadCodes();
  }

  async function deactivateCode(codeId: string) {
    await supabase.from('invitation_codes').update({ is_active: false }).eq('id', codeId);
    loadCodes();
  }

  if (loading) return <div className="container-content py-12"><p className="text-text-secondary">Laden...</p></div>;

  return (
    <div className="container-content py-12">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-serif">Einladungscodes</h1>
        <button onClick={() => setShowForm(true)} className="btn-primary">Neue Codes generieren</button>
      </div>

      {showForm && (
        <div className="mb-6 p-4 border border-surface-border rounded-sm">
          <h2 className="text-sm font-serif mb-3">Codes generieren</h2>
          <div className="flex gap-3 items-end">
            <div>
              <label className="block text-xs text-text-muted mb-1">Anzahl</label>
              <input type="number" value={count} onChange={(e) => setCount(parseInt(e.target.value))} className="input-field" min="1" max="100" />
            </div>
            <div>
              <label className="block text-xs text-text-muted mb-1">Gueltig bis (optional)</label>
              <input type="date" value={validUntil} onChange={(e) => setValidUntil(e.target.value)} className="input-field" />
            </div>
            <button onClick={generateCodes} className="btn-primary">Generieren</button>
            <button onClick={() => setShowForm(false)} className="btn-secondary">Abbrechen</button>
          </div>
        </div>
      )}

      <table className="min-w-full">
        <thead>
          <tr><th>Code</th><th>Erstellt</th><th>Gültig bis</th><th>Verwendet von</th><th>Status</th><th>Aktion</th></tr>
        </thead>
        <tbody>
          {codes.map((c) => (
            <tr key={c.id}>
              <td className="font-mono text-sm">{c.code}</td>
              <td className="text-sm">{formatDateTime(c.created_at)}</td>
              <td className="text-sm">{c.valid_until ? formatDateTime(c.valid_until) : '—'}</td>
              <td>{c.companies?.name || '—'}</td>
              <td>{c.is_active ? 'Aktiv' : 'Deaktiviert'}</td>
              <td>
                {c.is_active && (
                  <button onClick={() => deactivateCode(c.id)} className="text-sm btn-danger text-xs">Deaktivieren</button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
